<template>
  <CheckoutComponent />
</template>

<script>
// @ is an alias to /src
import CheckoutComponent from "@/components/Checkout/Checkout.vue";

export default {
  name: "Checkout",
  components: {
    CheckoutComponent
  }
};
</script>
